// src/components/DagdaAds.tsx

import "../styles/dagdaads.css";

const DagdaAds = () => {

  return (

    <div className="dagda-ad-banner">

      <div className="scroll-track">

        {/* GROUP 1 */}

        <div className="ad-group">

          <span>
            AI-Powered Protein Vending
          </span>

          <span>
            Zero Upfront Cost
          </span>

        </div>

        {/* GROUP 2 */}

        <div className="ad-group">

          <span>
            Smart Gym Partnerships
          </span>

          <span>
            Passive Revenue Stream
          </span>

        </div>

        {/* GROUP 3 */}

        <div className="ad-group">

          <span>
            Premium Protein Experience
          </span>

          <span>
            Exclusive Member Discounts
          </span>

        </div>

      </div>

    </div>

  );
};

export default DagdaAds;